import "./_accueil.scss";

import {useEffect, useState} from "react";

import {fetchOffres} from "@/api/offres";
import {FetchOperationsCommerciales} from "@/api/operationCommerciale";
import CardProduct from "@/components/CardProduct/CardProduct";
import {CardProduct as CardProductInterface} from "@/components/CardProduct/interface";
import Dropdown from "@/components/Dropdown/Dropdown";
import {Error} from "@/components/Error/Error";
import Loader from "@/components/Loader/loader";
import {NoOffre} from "@/components/NoOffre/NoOffre";
import CardOperationCommerciale from "@/components/OperationCommerciale/CardOperationCommerciale/CardOperationCommerciale";
import Palier from "@/components/Palier/Palier";
import Section from "@/components/Section/Section";
import Title from "@/components/Section/Title";
import {dateIsAfterNow, getDiffDay} from "@/function/dateFunction";
import {findDataArticle} from "@/function/findDataArticle";
import {formatDate} from "@/function/formatDate";
import {isPuriel} from "@/function/isPuriel";
import {
  getEngagementValue,
  getResumeEngagement,
} from "@/function/massificationTools";
import {Palier as PalierInterface} from "@/ts/interface/detailOffre";
import {Massifications, OffresReponse} from "@/ts/interface/offres";
import {CardOperationCommerciale as OperationCommerciale} from "@/ts/interface/operationCommerciale";

function Accueil(): JSX.Element {
  const [massifications, setMassification] = useState<Massifications[] | null>(
    null,
  );
  const [massificationLoad, setMassificationLoad] = useState<boolean>(true);
  const [massificationError, setMassificationError] = useState<Error | null>(
    null,
  );
  const [operationsCommerciales, setOperationsCommerciales] = useState<
    OperationCommerciale[] | null
  >(null);
  const [operationLoad, setOperationLoad] = useState<boolean>(true);
  const [operationError, setOperationError] = useState<Error | null>(null);

  const getOffres = async (): Promise<void> => {
    try {
      const reponse = await fetchOffres();
      if (reponse) {
        const {massifications}: OffresReponse = reponse;
        setMassification(massifications);
      }
      setMassificationLoad(false);
    } catch (error) {
      setMassificationError(error as Error);
      setMassificationLoad(false);
    }
  };
  const getOperationsCommerciales = async (): Promise<void> => {
    setOperationLoad(true);

    const filtre: string[] = [
      `date_engagement=${formatDate(new Date().toString())}`,
      "publication=true",
    ];
    try {
      const reponse = await FetchOperationsCommerciales(filtre);
      if (reponse) {
        const operations_commerciales = reponse;
        setOperationsCommerciales(operations_commerciales.operations);
      }
      console.log(reponse);
      setOperationLoad(false);
    } catch (error) {
      setOperationError(error as Error);
      setOperationLoad(false);
    }
  };
  useEffect(() => {
    //reset les error
    setOperationError(null);
    setMassification(null);

    getOperationsCommerciales();
    getOffres();
  }, []);
  const MassificationsComponent: JSX.Element[] | undefined =
    massifications?.map(massification => {
      const {
        articles,
        paliers,
      }: {
        articles: CardProductInterface[];
        paliers: PalierInterface[];
      } = massification;

      const ProduitComponent: JSX.Element[] = articles.map((article, index) => {
        const foundPalier: PalierInterface[] = findDataArticle(
          paliers,
          article.article_id,
        );
        const palierValeur: number[] | undefined = foundPalier?.map(palier => {
          return palier.nombre;
        });

        const {engagement_value} = getEngagementValue(massification, article);

        return (
          <CardProduct
            product={article}
            offreType="massification"
            offre_id={massification.offre_id}
            key={index}>
            <Palier
              paliers={palierValeur}
              current={engagement_value}
              typePalier={massification.type_palier}
            />
            <p id="nombre_engagement">
              {getResumeEngagement(massification, article)}
            </p>
          </CardProduct>
        );
      });
      const isActiveNow = dateIsAfterNow(massification.date_debut);
      const joursRestant: number = getDiffDay(
        isActiveNow ? massification.date_fin : massification.date_debut,
      );
      let joursRestantComponent: JSX.Element | string = "";
      if (joursRestant) {
        const messageDatesActivationOffre: JSX.Element = isActiveNow ? (
          <span>{`${joursRestant} jour${isPuriel(joursRestant)} restant${isPuriel(joursRestant)}`}</span>
        ) : (
          <span id="prochainement">{`PROCHAINEMENT disponible dans  ${joursRestant} jour${isPuriel(joursRestant)}`}</span>
        );
        joursRestantComponent =
          joursRestant > 0 ? (
            messageDatesActivationOffre
          ) : joursRestant === 0 ? (
            <span> DERNIER JOUR</span>
          ) : (
            <span> Opération clôturée</span>
          );
      }
      return (
        <Dropdown
          key={massification.offre_id}
          titre={massification.nom}
          complementTitre={joursRestantComponent}
          defaultOpen={false}>
          {ProduitComponent}
        </Dropdown>
      );
    });
  return (
    <>
      <Section id={"massification"}>
        <Title title="Opération de Massification" />
        {massificationError ? (
          <Error text={massificationError.message} variant="red" />
        ) : null}
        {massificationLoad ? (
          <Loader />
        ) : massifications && massifications.length < 1 ? (
          <NoOffre />
        ) : (
          <> {MassificationsComponent}</>
        )}
      </Section>
      <Section id={"operations_commerciales"}>
        <Title title="Opérations Commerciales " />
        <div className="operationList">
          {operationError ? (
            <Error text={operationError.message} variant="red" />
          ) : null}
          {operationLoad ? (
            <Loader />
          ) : (
            operationsCommerciales?.map(ope => {
              return (
                <CardOperationCommerciale
                  operation={ope}
                  refresh={getOperationsCommerciales}
                  key={ope.operation_id}
                />
              );
            })
          )}
        </div>
      </Section>
    </>
  );
}

export default Accueil;
